import { render, staticRenderFns } from "./AdresTuruPicker.vue?vue&type=template&id=350b8994&scoped=true"
import script from "./AdresTuruPicker.vue?vue&type=script&lang=ts"
export * from "./AdresTuruPicker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350b8994",
  null
  
)

export default component.exports